import React, { useState } from "react";
import Project from "./Project";
import { projects } from "../data/data";
import { motion, AnimatePresence } from "framer-motion";

const Projects = () => {
  const [showMore, setShowMore] = useState(false);
  const num = showMore ? projects.length : 6;

  const parent = {
    hidden: { opacity: 0, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,

      transition: { duration: 0.6 },
    },
    exit: {
      scale: 0,
      opacity: 0,
      transition: { duration: 0.9 },
    },
  };

  return (
    <section className="section " id="projects">
      <h1 className="title ">projects</h1>

      <div
        className={` grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center  justify-items-center gap-5  `}
      >
        <AnimatePresence>
          {projects.slice(0, num).map((elm, i) => (
            <motion.span
              key={i}
              variants={parent}
              initial="hidden"
              animate="visible"
              className="h-full w-full"
              exit="exit"
            >
              <Project data={elm} />
            </motion.span>
          ))}
        </AnimatePresence>
      </div>

      <div className=" text-center pt-5">
        <button
          onClick={() => setShowMore((prev) => !prev)}
          className=" bg-sky-400/80 w-[125px] hover:scale-105 hover:shadow-lg  shadow-md  transition-all ease-in-out text-white font-bold py-2 px-4 rounded"
        >
          Show {`${showMore ? "less" : "more"}`}
        </button>
      </div>
    </section>
  );
};

export default Projects;
